import React from "react";
import * as styles from "./ArticleContent.module.css";
import { CustomRichTextElement } from "../../components/elements/CustomRichTextElement/CustomRichTextElement";
import { KontentRichText, PageLink, Video } from "../../types";
import { Breadcrumbs as BreadcrumbsType } from "../Page/PageTypes";
import SidebarLinks from "./SidebarLinks";
import { Breadcrumbs } from "../../components/elements/Breadcrumbs/Breadcrumbs";
import { Equals } from "../../components/elements/Equals/equals";
import { PrintandShare } from "../../components/blocks/PrintandShare/PrintandShare";
import KnowledgeCenterListingContainer, {
  KnowledgeCenterListingProps,
} from "../../components/blocks/KnowledgeCenterListing/index";

interface Props {
  pageTitle: string;
  pageUrl: string;
  content?: KontentRichText;
  breadcrumbs?: BreadcrumbsType;
  advice: PageLink[];
  helpfulProducts: PageLink[];
  videos: Video[];
  moreNews: KnowledgeCenterListingProps;
}

const ArticleContent: React.FC<Props> = ({
  content,
  pageTitle,
  breadcrumbs,
  advice,
  helpfulProducts,
  videos,
  moreNews,
  pageUrl,
  ...props
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.utilityBar}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <PrintandShare
          pageTitle={pageTitle}
          pageUrl={pageUrl}
          width="full"
          id="print-and-share"
        />
      </div>
      <div className={styles.columnContainer}>
        <article>
          <div className={styles.articleContent}>
            <h1>{pageTitle}</h1>
            {content && <CustomRichTextElement content={content} />}
          </div>
        </article>

        <div className={styles.sidebar}>
          {advice.length > 0 && (
            <SidebarLinks heading="Advice" links={advice} />
          )}
          {helpfulProducts.length > 0 && (
            <SidebarLinks heading="Helpful Products" links={helpfulProducts} />
          )}
          {videos.length > 0 && (
            <SidebarLinks heading="Videos" videos={videos} />
          )}
          <Equals className={styles.equals} />
        </div>
      </div>
      {moreNews && (
        <div className={styles.moreNews}>
          <h2>More News From Emprise</h2>
          <KnowledgeCenterListingContainer {...moreNews} />
        </div>
      )}
    </div>
  );
};

export default ArticleContent;
